import {Injectable} from '@angular/core';
import {API_URLS} from '../../../../../environments/env-routes';
import {APIHelper} from '../../../../../shared/services/api-helper/api-helper.service';
import {Site} from '../models/site.model';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  public sites: Site[];
  public isOpen: boolean = false;
 public siteId:string;
  constructor(private api: APIHelper) {
    this.sites = [];
  }

  public getOne(siteId: string) {
    const routeToCall = API_URLS.sites.getOne.replace(':siteId', siteId);

    return this.api.requestApi({action: routeToCall}).then(res => {
      return res;
    });
  }

  public getMembers(siteId: string, getSource = false): Promise<any[]> {
    const routeMembers = API_URLS.sites.getMembersAndGroups.replace(
      ':siteId',
      siteId
    );

    return this.api
      .requestApi({action: routeMembers, queryArgs: 'authorityType=USER'})
      .then(res => {
        return res;
      });
  }

  public getGroups(siteId: string, getSource = false): Promise<any[]> {
    const routeMembers = API_URLS.sites.getMembersAndGroups.replace(
      ':siteId',
      siteId
    );

    return this.api
      .requestApi({action: routeMembers, queryArgs: 'authorityType=GROUP'})
      .then(res => {
        return res;
      });
  }

  public changeMemberPermission(
    siteId: string,
    userId: string,
    newPermission: string
  ): Promise<any> {
    const route = API_URLS.sites.changeUserPermissions
      .replace(':siteId', siteId)
      .replace(':memberId', userId);
    const dataSend = {
      role: newPermission
    };

    return this.api
      .requestApi({action: route, method: 'PUT', datas: dataSend})
      .then(res => {
        return res;
      });
  }

  public changeGroupPermission(
    siteId: string,
    groupId: string,
    newPermission: string
  ): Promise<any> {
    const route = API_URLS.sites.getMembersAndGroups.replace(':siteId', siteId);
    const dataSend = {
      role: newPermission,
      group: {
        fullName: groupId
      }
    };

    return this.api
      .requestApi({action: route, method: 'PUT', datas: dataSend})
      .then(res => {
        return res;
      });
  }

  public addGroupAndMembers(
    siteId: string,
    groups: any[],
    members: any[]
  ): Promise<any> {
    const routeGroup = API_URLS.sites.getMembersAndGroups.replace(
      ':siteId',
      siteId
    );
    const routeMember = API_URLS.sites.invitationMembers.replace(
      ':siteId',
      siteId
    );
    const promises = [];

    for (const group of groups) {
      const dataSend = {
        role: group.role,
        group: {
          fullName: group.properties['cm:authorityName']
        }
      };

      promises.push(
        this.api
          .requestApi({action: routeGroup, method: 'POST', datas: dataSend})
          .catch(() => true)
      );
    }

    for (const person of members) {
      const dataSend = {
        acceptURL: '/',
        rejectURL: '/',
        invitationType: 'NOMINATED',
        inviteeUserName: person.properties['cm:userName'],
        inviteeRoleName: person.role,
        inviteeFirstName: person.properties['cm:firstName'],
        inviteeLastName: person.properties['cm:lastName'],
        inviteeEmail: person.properties['cm:email']
      };

      promises.push(
        this.api
          .requestApi({action: routeMember, method: 'POST', datas: dataSend})
          .catch(() => true)
      );
    }

    return Promise.all(promises);
  }

  public delete(siteId: string, elementId: string): Promise<any> {
    const route = API_URLS.sites.delete
      .replace(':siteId', siteId)
      .replace(':elementId', elementId);

    return this.api.requestApi({action: route, method: 'DELETE'});
  }

  public deleteSite(siteName: string): Promise<boolean> {
    return this.api
      .requestApi({
        action: API_URLS.sites.deleteSite.replace(':shortName', '' + siteName),
        method: 'DELETE'
      })
      .then(res => {
        return true;
      });
  }

  public createFolder(data: any): Promise<any> {
    return this.api.requestApi({
      action: API_URLS.sites.createFolder,
      method: 'POST',
      datas: data
    });
  }

  public getSiteIdFromFileElements(file) {
    let siteId = null;
    
    file.path.elements.forEach((e) => {
      if(e.nodeType === 'st:site') {
        siteId = e.name;
        return;
      }
    });

    return siteId;
  }
}
